module.exports = __webpack_public_path__ + "static/media/komme_nærmere.56cbc28f.m4a";